module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chapter",
    attrs: {
      "id": "heading_id_4"
    }
  }, [_vm._v("Author’s Note")]), _vm._v(" "), _c('p', [_vm._v("This is a work of fiction. While there were actual people named Leonard Williams, George Whitacre, Arthur Dollison, Marvin Hubbard, Frank Morris, Bernie Coy, Allen West, Clarence Anglin, Joe Cretzer, Billy Boggs, John Anglin, and Clarence Carnes, this novel is not intended to be an accurate portrayal of their personalities, nor is it intended to be a complete or factual account of the actions these individuals took in real life. All other characters in this story are entirely fictional and any resemblance to actual persons, living or dead, is coincidental.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5fd0c852","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book1/Text/authornote.vue
// module id = 84
// module chunks = 0